
import { DeviceFeaturesSection } from "./DeviceFeaturesSection";

interface Device {
  id: string;
  name: string;
  user: string;
  os: string;
  version: string;
  status: "active" | "prepared" | "inactive";
  lastSync: string;
  group: string;
}

interface DeviceFeaturesTabProps {
  device: Device;
}

export const DeviceFeaturesTab = ({ device }: DeviceFeaturesTabProps) => {
  return (
    <div className="p-3 h-full overflow-auto">
      <DeviceFeaturesSection deviceId={device.id} />
    </div>
  );
};
